/* eslint-disable react/jsx-props-no-spreading */
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Button, Collapse, CollapseProps, Paper, Stack, Typography } from '@mui/material';
import React, { ReactNode, useState } from 'react';

import { useLocalStorage } from '../../hooks/useLocalStorage';

interface CollapsiblePaperProps extends CollapseProps {
  title: string;
  // Instance key to identify this collapsible paper in local storage.
  // So that its open/closed state can be remembered across sessions
  sessionKey?: string;
  children: ReactNode;
  summary?: ReactNode;
}

function CollapsiblePaper({ title, sessionKey = '', children, summary, ...rest }: CollapsiblePaperProps) {
  const [isInByDefault, setInByDefault] = useLocalStorage(`collapsible-paper-${sessionKey}`, false);
  const [isIn, setIn] = useState(rest.in || (sessionKey && isInByDefault));

  const setOpen = (newOpen: boolean) => {
    setIn(newOpen);
    if (sessionKey) {
      setInByDefault(newOpen);
    }
  };

  return (
    <Paper sx={{ width: '100%' }}>
      <Stack p={2} spacing={1}>
        <Button variant="text" size="large" color="inherit" fullWidth onClick={() => setOpen(!isIn)}>
          <Typography sx={{ marginRight: 'auto' }}>{title}</Typography>
          {isIn ? <ExpandLess /> : <ExpandMore />}
        </Button>
        {summary}
        <Collapse timeout="auto" unmountOnExit={false} {...rest} in={isIn}>
          {children}
        </Collapse>
      </Stack>
    </Paper>
  );
}

export default CollapsiblePaper;
